import I18n from '../../config/i18n';
import type { Accommodation } from '../../routes/reducers/types';

interface AccommodationKindNameProps {
  accommodation: Pick<Accommodation, 'kind'>;
  suite: boolean;
}
export default function AccommodationKindName({
  accommodation,
  suite,
}: AccommodationKindNameProps): JSX.Element | null {
  if (suite) {
    return <>{I18n.t('host.suite')}</>;
  }
  switch (accommodation.kind) {
    case 'holiday_home':
      return <>{I18n.t('host.holiday_home')}</>;
    case 'apartment':
      return <>{I18n.t('host.apartment')}</>;
    default:
      return null;
  }
}
